import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { Partner } from '../../../../partners';
import NumberView from 'shared/components/NumberView';

import './index.scss';

import iconFollower from './static/img/follower.svg';

interface Props {
  partner: Partner;
  big?: boolean;
  onClick?: () => void;
}

const b = b_.with('main-page-partners-item');

const Item: React.FC<Props> = ({ partner, big, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={b({ big })}>
      <div className={b('wrapper')} onClick={onClick}>
        <div className={b('img')}>
          <img src={partner.img} alt={partner.name} />
        </div>
        <div className={b('name')}>{partner.name}</div>
        <div className={b('position')}>{partner.positionInCompany}</div>
      </div>
      {partner.followers && (
        <a href={partner.channelLink} className={b('followers')} target="_blank" rel="noopener">
          <NumberView>{partner.followers}</NumberView>{' '}
          <>
            <svg className={b('followers-img')}>
              <use xlinkHref={`${iconFollower}#icon-follower`} />
            </svg>
            <div>
              {partner.channel === 'Telegram' ? t('in') : t('on')} {partner.channel}
            </div>
          </>
        </a>
      )}
    </div>
  );
};

export default Item;
